// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"b1fda248","58":"4781f7e9","214":"cf75d55f","228":"2b58f8c7","344":"26c17bc2","434":"b5da3a83","523":"7785ab50","552":"3ee1cb8f","561":"b5120885","862":"8260ae49","878":"6068b425","900":"f67e92cf","969":"045cf56f"}[chunkId] + ".chunk.js";
};